import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import Modal from "react-modal";
import "./SignUpScreen.css";
import logo from "../assets/images/logo_cyber_112.png";
import Swal from 'sweetalert2';

Modal.setAppElement("#root");

const SignUpScreen = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [companyCode, setCompanyCode] = useState("");
  const [activationCode, setActivationCode] = useState("");
  const [error, setError] = useState("");
  const [modalVisible, setModalVisible] = useState(false);

  // Uklonili smo: resultModalOpen, resultMessage, resultType

  const handleSignUpClick = () => {
    setError("");

    if (!firstName || !lastName || !username || !password || !confirmPassword) {
      setError("Please fill in all fields.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (!selectedRole) {
      setError("Please select a role.");
      return;
    }

    if (!privacyAccepted) {
      setError("You must accept the privacy policy.");
      return;
    }

    setModalVisible(true);
  };

  const handleSignUp = async () => {
    console.log("🔵 handleSignUp START");
    setError("");

    if (!companyCode) {
      console.log("❌ Missing companyCode");
      setError("Please enter the company activation code");
      return;
    }

    if (selectedRole !== "4" && !activationCode) {
      console.log("❌ Missing activationCode");
      setError("Please enter the activation code");
      return;
    }

    console.log("🟢 Validation passed");

    const payload = {
      firstName,
      lastName,
      username,
      password,
      role: parseInt(selectedRole, 10),
      privacy: privacyAccepted,
      companyCode,
      activationCode: selectedRole !== "4" ? activationCode : "",
    };

    console.log("📦 Payload sending:", payload);

    try {
      console.log("📡 POST /user/register");
      const response = await API.post("/user/register", payload);

      console.log("🟣 RESPONSE:", response.data);

      if (response.data.succes === true) {
        console.log("🟢 Registration succeeded");

        // Zatvori modal
        setModalVisible(false);

        // SweetAlert za uspjeh
        Swal.fire({
          title: 'Success!',
          text: response.data.status || 'Registration successful!',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#E31298',
          customClass: {
            popup: 'custom-swal-popup',
            title: 'swal-title',
            htmlContainer: 'swal-text'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/login");
          }
        });

      } else {
        console.log("🔴 Registration failed:", response.data.status);

        // SweetAlert za grešku
        Swal.fire({
          title: 'Error!',
          text: response.data.status || 'Registration failed',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
          background: '#fef2f2', // Dodajte željenu boju pozadine ovdje
          customClass: {
            popup: 'custom-swal-popup-error',
            title: 'swal-title',
            htmlContainer: 'swal-text'
          }
        });
      }

    } catch (err) {
      console.log("💥 API ERROR:", err.message);

      // SweetAlert za API grešku
      Swal.fire({
        title: 'Error!',
        text: err.response?.data?.message || err.message || 'Something went wrong',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
        customClass: {
          popup: 'custom-swal-popup-error',
          title: 'swal-title',
          htmlContainer: 'swal-text'
        }
      });
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-box">
        <img src={logo} alt="Logo" className="signup-logo" />
        <h2>Create New Account</h2>

        <div className="input-row">
          <input
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className="input-half"
          />

          <input
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className="input-half"
          />
        </div>

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="input-new"
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input-new"
        />

        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="input-new"
        />

        <p className="role-label">Select Your Role:</p>
        <div className="role-container">
          {[
            { label: "Employee", value: "4" },
            { label: "Manager", value: "2" },
            { label: "Executive", value: "3" },
            { label: "Admin", value: "1" },
          ].map((role) => (
            <button
              key={role.value}
              className={`role-button ${selectedRole === role.value ? "selected" : ""}`}
              onClick={() => setSelectedRole(role.value)}
            >
              {role.label}
            </button>
          ))}
        </div>

        <div className="privacy-container">
          <input
            type="checkbox"
            id="privacy"
            checked={privacyAccepted}
            onChange={() => setPrivacyAccepted(!privacyAccepted)}
          />
          <label htmlFor="privacy"></label>
          <p>
            I accept the <span className="privacy-link" onClick={() => navigate("/privacy")}>Privacy Policy</span>
          </p>
        </div>

        {error && <p className="error-message">{error}</p>}

        <button className="signup-button" onClick={handleSignUpClick}>Sign Up</button>

        <Modal
          isOpen={modalVisible}
          onRequestClose={() => setModalVisible(false)}
          className="modal-content"
          overlayClassName="modal-overlay"
          shouldCloseOnOverlayClick={true}
        >
          <h3>{selectedRole === "4" ? "Activation Code" : "Activation Codes"}</h3>
          {selectedRole !== "4" && <p>Please enter both activation codes:</p>}

          <input
            type="text"
            placeholder="Company activation code"
            value={companyCode}
            onChange={(e) => setCompanyCode(e.target.value)}
          />
          {selectedRole !== "4" && (
            <input
              type="text"
              placeholder="Activation Code"
              value={activationCode}
              onChange={(e) => setActivationCode(e.target.value)}
            />
          )}

          {error && <p className="error-message">{error}</p>}

          <div className="modal-buttons">
            <button onClick={() => setModalVisible(false)} className="modal-cancel">Cancel</button>
            <button onClick={handleSignUp} className="modal-confirm">Submit</button>
          </div>
        </Modal>

        <p className="login-text">
          Already have an account?{" "}
          <span onClick={() => navigate("/login")} className="login-link">Log In</span>
        </p>
      </div>
    </div>
  );
};

export default SignUpScreen;